const LoadingDiv = () => {
    return (
        <div className="py-24 flex justify-center flex-col items-center">
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <h1 className="text-xl font-medium py-2 text-green-app">Loading...</h1>
        </div>
    )
}

export default LoadingDiv